<template>
    <div
        v-if="filterState && filterState.length > 0 && hasFilterChips"
        class="table-filter-chips px-6 pb-4"
        :data-cy="`table.filter.chips`"
    >
        <template v-for="(filter, index) in filterState">
            <div
                v-if="!filter.search"
                :key="`FilterChip_${index}`"
                class="chip mr-3 py-2 px-3"
                :data-cy="`table.filter.chip-${index}`"
                :class="`${filter.filterLabel}`"
                @click="removeFilter(filter)"
            >
                <p class="pl-1 white--text">{{ chipText(filter) }}</p>
                <font-awesome-icon
                    icon="fas fa-xmark"
                    class="icon icon-close ml-2 white--text"
                ></font-awesome-icon>
            </div>
        </template>
    </div>
</template>

<script setup>
import moment from 'moment';
import { ref, computed } from 'vue';

const emit = defineEmits(['remove-filter']);
const props = defineProps({
    filterState: {
        type: Array,
        default: () => [],
    },
});

const displayFormat = ref('MM/DD/YYYY');

const hasFilterChips = computed(() => {
    return props.filterState.findIndex(val => !val.search) === -1 ? false : true;
});

const removeFilter = filter => {
    emit('remove-filter', filter);
};

const chipText = (filter) => {
    if (filter.filterType === 'Empty') {
        return `${filter.filterLabel} is Empty`;
    }
    if (!filter.filterValue) return;
    if (filter.filterType === 'date range' || filter.filterType === 'date-time range') {
        const dates = filter.filterValue.split('|');
        const formattedStartDate = moment(dates[0]).format(displayFormat.value);
        const formattedEndDate = moment(dates[1]).format(displayFormat.value);

        return `${filter.filterLabel}: ${formattedStartDate} - ${formattedEndDate}`;
    }
    if(filter.filterType === 'range' &&  filter.filterDisplay ){
        return `${filter.filterLabel}: ${filter.filterDisplay}`
    }
    return `${filter.filterLabel} ${filter.filterType.toLowerCase()} ${filter.filterValue.replace('|', ' to ')}`;
};
</script>

<script>
export default {
    name: 'TableFilterChips',
};
</script>

<style lang="scss" scoped>
.table-filter-chips {
    .chip {
        display: flex;
        align-items: center;
        cursor: pointer;
        display: inline-flex;
        border-radius: 18px;
        background: $tealDark;

        .icon {
            height: 16px;
            width: 16px;
        }
        &:hover {
            p {
                color: white;
                text-decoration: underline;
            }
        }
    }
}
</style>
